// COOODEX® Partner-Landing — Interaktionen (Audit-Umsetzung 2026-06-11)
// - Scroll-Reveals, Progress-Bar, Cursor-Glow, Trust-Banner-Animation
// - Lazy-Loading für Hero- und Story-Video via IntersectionObserver (Performance)
// - H1-Begrüßung für eingeloggte Fachpartner (PLAYBOOK Punkt 10)
(function () {
  'use strict';

  // ── Intersection Observer für Scroll-Animationen
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.pillar, .trust-item, .reason, .fade-up, .seg-card, .pl-fact').forEach(function (el) {
    revealObserver.observe(el);
  });

  // ── Scroll Progress Bar
  var scrollProgress = document.getElementById('scrollProgress');
  window.addEventListener('scroll', function () {
    var scrollTop = document.documentElement.scrollTop;
    var scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
    if (scrollProgress) scrollProgress.style.width = progress + '%';
  }, { passive: true });

  // ── Cursor Glow (nur Hero)
  var glow = document.getElementById('cursorGlow');
  var hero = document.getElementById('hero');
  if (glow && hero) {
    document.addEventListener('mousemove', function (e) {
      glow.style.left = e.clientX + 'px';
      glow.style.top = e.clientY + 'px';
      var heroRect = hero.getBoundingClientRect();
      glow.style.opacity = e.clientY >= heroRect.top && e.clientY <= heroRect.bottom ? '1' : '0';
    });
  }

  // ── Videos lazy laden (Hero + Story): erst bei Sichtbarkeit nachladen & abspielen
  var lazyVideos = document.querySelectorAll('video[data-lazy-video]');
  if (lazyVideos.length) {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var videoObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var video = entry.target;
        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.src = source.getAttribute('data-src');
          source.removeAttribute('data-src');
        });
        video.load();
        if (!prefersReducedMotion) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }
        obs.unobserve(video);
      });
    }, { rootMargin: '200px 0px' });
    lazyVideos.forEach(function (video) { videoObserver.observe(video); });
  }

  // ── Trust-Banner: Squeeze + Sparks
  var wowLine = document.querySelector('.wow-line');
  if (wowLine) {
    var text = wowLine.dataset.text;
    wowLine.innerHTML = '';
    var sparkContainer = document.createElement('div');
    sparkContainer.className = 'spark-container';
    wowLine.appendChild(sparkContainer);
    var flash = document.createElement('div');
    flash.className = 'wow-flash';
    wowLine.appendChild(flash);

    text.split('').forEach(function (ch, i) {
      var span = document.createElement('span');
      span.className = 'char';
      span.textContent = ch === ' ' ? '\u00A0' : ch;
      span.style.animationDelay = (i * 0.03) + 's';
      wowLine.insertBefore(span, sparkContainer);
    });

    var spawnSparks = function () {
      sparkContainer.innerHTML = '';
      var count = 30;
      for (var i = 0; i < count; i++) {
        var s = document.createElement('div');
        s.className = 'spark';
        var angle = Math.random() * Math.PI * 2;
        var dist = 60 + Math.random() * 100;
        s.style.setProperty('--sx', Math.cos(angle) * dist + 'px');
        s.style.setProperty('--sy', Math.sin(angle) * dist + 'px');
        s.style.setProperty('--dur', (0.5 + Math.random() * 0.6) + 's');
        s.style.setProperty('--d', (Math.random() * 0.3) + 's');
        s.style.left = (Math.random() * 100) + '%';
        s.style.top = (Math.random() * 100) + '%';
        sparkContainer.appendChild(s);
        requestAnimationFrame(function (el) {
          return function () { el.classList.add('fly'); };
        }(s));
      }
    };

    var wowObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          wowLine.classList.remove('active');
          flash.classList.remove('active');
          void wowLine.offsetWidth; // Reflow erzwingen
          wowLine.classList.add('active');
          flash.classList.add('active');
          spawnSparks();
          setTimeout(function () {
            wowLine.classList.remove('active');
            flash.classList.remove('active');
            wowLine.querySelectorAll('.char').forEach(function (c) {
              c.style.opacity = '1';
              c.style.transform = 'scaleY(1) scaleX(1)';
              c.style.filter = 'blur(0)';
            });
          }, 2500);
        }
      });
    }, { threshold: 0.5 });
    var wowBanner = document.getElementById('wowBanner');
    if (wowBanner) wowObserver.observe(wowBanner);
  }

})();